import { ChatsChannelType } from '../../../constants/types';

export const defaultSettingsPage = [
  { type: ChatsChannelType.whatsapp },
  { type: ChatsChannelType.facebook },
  { type: ChatsChannelType.telegram },
  { type: ChatsChannelType.instagram },
  { type: ChatsChannelType.viber }
];
